(() => {
  if (window.CollectionHeroDescription) {
    window.CollectionHeroDescription.init();
    return;
  }

  const init = (root = document) => {
    root.querySelectorAll('.collection-hero__description').forEach((description) => {
      const toggle = description.nextElementSibling;
      if (description.dataset.clampReady || !toggle || !toggle.classList.contains('collection-hero__toggle')) return;
      description.dataset.clampReady = 'true';

      const update = () => {
        if (description.classList.contains('is-expanded')) return;
        description.classList.remove('is-clamped');

        const top = description.getBoundingClientRect().top;
        const maxLineHeight = parseFloat(getComputedStyle(description).fontSize) * 2.5;
        const range = document.createRange();
        range.selectNodeContents(description);
        const rects = Array.from(range.getClientRects())
          .filter((rect) => rect.width && rect.height <= maxLineHeight)
          .sort((a, b) => a.top - b.top);
        const bottoms = [];
        let lineTop = -Infinity;
        rects.forEach((rect) => {
          if (rect.top - lineTop > rect.height / 2) {
            bottoms.push(rect.bottom);
            lineTop = rect.top;
          } else {
            bottoms[bottoms.length - 1] = Math.max(bottoms[bottoms.length - 1], rect.bottom);
          }
        });
        const clampLines = window.matchMedia('(max-width: 749px)').matches ? 3 : 2;
        if (bottoms.length <= clampLines) return;

        description.style.setProperty('--clamp-height', `${Math.ceil(bottoms[clampLines - 1] - top)}px`);
        description.classList.add('is-clamped');
      };

      toggle.addEventListener('click', () => {
        const expanded = description.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        if (!expanded) update();
      });

      let frame;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      });
      if (document.fonts) document.fonts.ready.then(update);
      update();
    });
  };

  window.CollectionHeroDescription = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
